import { render, staticRenderFns } from "./OutGoingLetterDetail.vue?vue&type=template&id=5e9d06bd&scoped=true"
import script from "./OutGoingLetterDetail.vue?vue&type=script&lang=js"
export * from "./OutGoingLetterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9d06bd",
  null
  
)

export default component.exports